import { useEffect } from "react";
import { Location, useLocation, useNavigate } from "react-router-dom";
import { APP_URLS } from "../../constants/appConstants";
import { consumeRedirectPath, isSafeRedirectPath } from "../../utils/redirectUtils";

interface AuthenticationRouteProp {
    component: JSX.Element;
    authed: boolean;
    path?: string;
}

interface AuthenticationRouteState {
    from?: Pick<Location, "pathname" | "search">;
}

const AuthenticationRoute = (props: AuthenticationRouteProp) => {
    const navigate = useNavigate();
    const location = useLocation();
    const fromLocation = (location.state as AuthenticationRouteState | null)?.from;
    const from = fromLocation ? `${fromLocation.pathname}${fromLocation.search ?? ""}` : null;

    // Once signed in, leave the login page for the page the user originally asked for.
    useEffect(() => {
        if (props.authed) {
            const savedPath = consumeRedirectPath();
            navigate(savedPath ?? (isSafeRedirectPath(from) ? from : `../${APP_URLS.DASHBOARD}`));
        }
    }, [props.authed, from, navigate]);

    return props.component;
};

export default AuthenticationRoute;
